<template>
  <div class="text-center">
    <v-snackbar
      v-model="applicationStore.userNotification.show"
      :timeout="applicationStore.userNotification.timeout"
      :color="applicationStore.userNotification.type"
      rounded="lg"
      width="100%"
      :class="applicationStore.userNotification.fullWidth ? 'full-width' : ''"
      close-on-content-click
    >
      {{ applicationStore.userNotification.message }}
    </v-snackbar>
  </div>
</template>

<script setup lang="ts">
import { useApplicationStore } from "@/store/application";

const applicationStore = useApplicationStore();
</script>

<style>
.full-width > .v-snackbar__wrapper {
  max-width: unset !important;
}
</style>
